import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.c1{align-items:flex-start;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.cq{background:var(--palette-white);}.ssr-plugin'
import '.a2{flex-direction:row;}.ssr-plugin'
import '.cp{justify-content:flex-start;}.ssr-plugin'
import '.dg{gap:2.5rem;}.ssr-plugin'
import '.c2{flex-wrap:wrap;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.aq{gap:0.5rem;}.ssr-plugin'
import '.k6{font-size:4rem;}.ssr-plugin'
import '.ds{font-weight:700;}.ssr-plugin'
import '.k7{line-height:100%;}.ssr-plugin'
import '.go{margin:0px;}.ssr-plugin'
import '.ak{color:var(--brand-secondary);}.ssr-plugin'
import '.al{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="d e c1 c cq"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="d a2 cp c1 dg c2"
      >
        {items.map((item, index) => (
          <div className="d e v aq"
            key={index}
          >
            <div className="k6 ds k7 go ak al"
            >
              {item.total}
            </div>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
